import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { sportscasterRouteOptions } from './data'
import { SportscasterConfig, SportscasterState } from './types'

export const initialSportscasterState: SportscasterState = {
  selectedHost: null,
  configs: {},
  health: {},
  data: {
    payload: null
  },
  events: [],
  routeOptions: sportscasterRouteOptions
}

export const sportscasterSlice = createSlice({
  name: 'sportscaster',
  initialState: initialSportscasterState,
  reducers: {
    setSelectedSportscasterHost: (
      state,
      action: PayloadAction<SportscasterState['selectedHost']>
    ) => {
      state.selectedHost = action.payload
    },
    setSportscasterConfig: (
      state,
      action: PayloadAction<SportscasterConfig>
    ) => {
      state.configs[action.payload.host] = action.payload
    },
    setSportscasterHealth: (
      state,
      action: PayloadAction<{ host: string; healthy: boolean }>
    ) => {
      state.health[action.payload.host] = action.payload.healthy
    },
    setSportscasterData: (
      state,
      action: PayloadAction<SportscasterState['data']>
    ) => {
      state.data = action.payload
    },
    addSportscasterEvent: (state, action: PayloadAction<any>) => {
      state.events.push(action.payload)
    }
  }
})

export const reducer = sportscasterSlice.reducer

export const {
  setSelectedSportscasterHost,
  setSportscasterConfig,
  setSportscasterHealth,
  setSportscasterData,
  addSportscasterEvent
} = sportscasterSlice.actions
